import { useEffect } from "react";

// Shared registration shape for the grids' export menus: whenever the filter
// or sort inputs change, hand the menu a fresh export-data builder. The
// builder itself only runs at export time (menu click), so nothing here
// computes eagerly. Export must cover every record matching the current
// filters, not the 21-row server page on screen, and Risk Summary cells are
// fetched for the full export set; grids supply that behavior through
// buildRiskAwareExportData.
export const useGridExportRegistration = (handleExportDataReady, buildGetData, deps) => {
  useEffect(() => {
    handleExportDataReady(() => buildGetData());
    // The caller owns the dependency list: it names the filter and sort
    // inputs its builder closes over.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
